import { inject, Injectable } from '@angular/core';
import { SessionApiProvider } from '@app/core/session/session-api-provider';
import { Observable, switchMap } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { SettingsService } from '@app/core/settings/settings.service';
import { SessionOidcApiService } from '@app/core/session/session-oidc-api.service';
import { SessionApiService } from './session-api.service';

@Injectable()
export class SessionApiMigrationProviderService implements SessionApiProvider {

  private readonly settingsService = inject(SettingsService);
  private readonly oidcProvider = inject(SessionOidcApiService);
  private readonly oldProvider = inject(SessionApiService);

  public signOut(): Observable<unknown> {
    return this.getProvider()
      .pipe(
        switchMap(provider => provider.signOut()),
      );
  }

  public authenticateBasically(): Observable<boolean> {
    return this.getProvider()
      .pipe(
        switchMap(provider => provider.authenticateBasically()),
      );
  }

  private getProvider(): Observable<SessionApiProvider> {
    return this.settingsService.getSettingsOnce()
      .pipe(
        map(settings => settings.isHybridLoginFlow() ? this.oidcProvider : this.oldProvider),
        first(),
      );
  }
}
